export default __webpack_public_path__ + "static/media/pantry2-after2-768w.e5f89ddb.png";